import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button, InputText, Toast } from "primereact";

// ------------------ COMPONENTES DE BASE --------------------------------
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { obtenerCountries } from "../../../../Base/API/Global/Countries/CountriesRequests";

// ------------------- CONSULTAS A LA API --------------------------------
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { getProveedorAct } from "../../../../API/Compras/Proveedores/ProveedoresRequest";
import { EditarLote, GuardarLote } from "../../../../API/MateriaPrima/MateriaPrimaRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------

const LotesCRUD = ({
  selected,
  getInfo = () => {},
  modo,
  onHide = () => {}
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [contries, setCountries] = useState([]);

  const initialValues = {
    IdLote: selected ? selected?.IdLote : -1,
    IdEstado: selected?.length > 0 ? selected?.IdEstado : 64,
    StatusName: selected?.length > 0 ? selected?.StatusName : 'Activo',
  };


  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
 
    const estadosTempo = await getEstadosCategory('Lotes')
    setEstados(estadosTempo)

    const proveedorTempo = await getProveedorAct()
    setProveedores(proveedorTempo)

    const countriesTempo = await obtenerCountries()
    setCountries(countriesTempo)
    if(selected){
      setValues({
        ...selected,
        IdLote: selected ? selected?.IdLote : -1,
        IdEstado: selected?.length > 0 ? selected?.IdEstado : 64,
        StatusName: selected?.length > 0 ? selected?.StatusName : 'Activo',
      })
    }

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.NoLote) {
      error.NoLote = true;
      error.error = true;
    }
    if (!values.CustomerName) {
        error.CustomerName = true;
        error.error = true;
    }
    if (!values.Country) {
        error.Country = true;
        error.error = true;
    }
    if (!values.StatusName) {
        error.IdEstado = true;
        error.error = true;
    }


    setError(error);
    return error;
  };

  const agregarLote = async () => {
    const e = verificarInfo();
    if(!e?.error){
      const Datos = {
        IdLote: values?.IdLote ? values?.IdLote : -100,
        NoLote: values?.NoLote,
        Comentario: values?.Comentario,
        IdEstado: values?.StatusName?.IdStatus || values?.IdEstado,
        IdVendor: values?.CustomerName?.IdVendor || values?.IdVendor,
        IdCountry: values?.Country?.IdCountry || values?.IdCountry,
        IdUserCreate: userAuth?.IdUser,
        IdUsesEdit: userAuth?.IdUser,
      }

      setLoading(true)
      if(Datos?.IdLote > 0){
          const respuesta = await EditarLote(Datos)
          if (respuesta[0].ESTADO !== -1) {
              toastShow(toast, "success", "Editada", respuesta[0].MENSAJE);
              setTimeout(() => {
                  onHide();
                  setLoading(false);
                  getInfo();
              }, 1500);
          } else {
              toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
              setLoading(false);
          }
      }else{
          const respuesta = await GuardarLote(Datos)
          if (respuesta[0].ESTADO !== -1) {
              toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
              setTimeout(() => {
                  onHide();
                  setLoading(false);
                  getInfo();
              }, 1500);
          } else {
              toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
              setLoading(false);
          }
      }
    }
  };

  useEffect(() => {
      getValoresIniciales();
  }, []);

  useEffect(() => {
    if(modo === "Crear" && selected.length === 0){
      setValues({
        ...values,
        IdCountry:  values?.CustomerName?.IdCountry,
        Country: values?.CustomerName?.Country})
     }else{
      setValues({
        ...values,
        IdCountry:  values?.IdCountry,
        Country: values?.Country})
     }
  }, [values?.CustomerName]);

  const dialodTitle = modo === "Crear" && selected.length === 0 ? "Agregar Lote" : "Editar Lote"

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialodTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2  mt-2">
              <span className="p-float-label">
                <InputText
                  name="NoLote"
                  value={values.NoLote}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  labelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.NoLote ? "p-invalid" : ""}
                />
                <label htmlFor="NoLote">No. Lote</label>
              </span>
            </div>

            <div className="field col-6 me-2  mt-2">
              <span className="p-float-label">
                <InputText
                  name="Comentario"
                  value={values.Comentario}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  labelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.Comentario ? "p-invalid" : ""}
                />
                <label htmlFor="Comentario">Comentario</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"CustomerName"}
                  value={values.CustomerName}
                  items={proveedores}
                  field={"CustomerName"}
                  label={"Proveedor"}
                  handleInputChange={handleInputChange}
                  className={error.CustomerName ? "p-invalid" : ""}
                />
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Country"}
                  value={values.Country}
                  items={contries}
                  field={"Country"}
                  label={"País"}
                  handleInputChange={handleInputChange}
                  className={error.Country ? "p-invalid" : ""}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"StatusName"}
                  value={values.StatusName}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  className={error.IdEstado ? "p-invalid" : ""}
                />
              </span>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-text"
              onClick={onHide}
            />
            <Button
              label={"Guardar"}
              icon="pi pi-check"
              className="p-button-text"
              onClick={agregarLote}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LotesCRUD;
